export const businessProduct = [
  { text: '-- Select --', disabled: true, value: '' },

  { text: 'Treasury', disabled: true, value: '' },
  { text: 'Deposit', disabled: false, value: 'Deposit' },
  { text: 'Foreign Exchange', disabled: false, value: 'Foreign Exchange' },

  { text: 'Deposits', disabled: true, value: '' },
  { text: 'Current Account-𝘪', disabled: false, value: 'Current Account-i' },

  { text: 'Deposits', disabled: true, value: '' },
  { text: 'Term Deposit-𝘪', disabled: false, value: 'Term Deposit-i' },
  { text: 'Floating Rate Term Deposit-𝘪', disabled: false, value: 'Floating Rate Term Deposit-i' },
  {
    text: 'Commodity Murabahah Current Account-𝘪',
    disabled: false,
    value: 'Commodity Murabahah Current Account-i'
  },
  {
    text: 'Commodity Murabahah Foreign Currency Current Account-𝘪',
    disabled: false,
    value: 'Commodity Murabahah Foreign Currency Current Account-i'
  },

  { text: 'Financing', disabled: true, value: '' },
  { text: 'Cashline-𝘪', disabled: false, value: 'Cashline-i' },
  { text: 'Commodity Financing-𝘪', disabled: false, value: 'Commodity Financing-i' },
  {
    text: 'Structured Commodity Financing-𝘪',
    disabled: false,
    value: 'Structured Commodity Financing-i'
  },
  { text: 'Trade Finance', disabled: false, value: 'Trade Finance' },
  { text: 'Letter of Credit-𝘪', disabled: false, value: 'Letter of Credit-i' },
  { text: 'Shipping Guarantee-𝘪', disabled: false, value: 'Shipping Guarantee-i' },
  { text: 'Bank Guarantee-𝘪', disabled: false, value: 'Bank Guarantee-i' },
  {
    text: 'Trade Commodity Financing-𝘪',
    disabled: false,
    value: 'Trade Commodity Financing-i'
  },
  { text: 'Bills for Collection-𝘪', disabled: false, value: 'Bills for Collection-i' },
  { text: 'Syndication Financing', disabled: false, value: 'Syndication Financing' },

  { text: 'Global Markets', disabled: true, value: '' },
  {
    text: 'Financial Institutions',
    disabled: false,
    value: 'Financial Institutions'
  },

  { text: 'Cash Management', disabled: true, value: '' },
  {
    text: 'alrajhicashbiz@24seven',
    disabled: false,
    value: 'alrajhicashbiz@24seven'
  },
  {
    text: 'e-Payment',
    disabled: false,
    value: 'e-Payment'
  }
]

export const personalProduct = [
  {
    text: '--Select--',
    disabled: true,
    value: ''
  },

  {
    text: 'Personal Financing-𝘪 Reward Plus Campaign',
    disabled: false,
    value: 'reward-plus-campaign'
  },
  {
    text: 'Power Pair Campaign',
    disabled: false,
    value: 'power-pair-campaign'
  },
  {
    text: 'MY alrajhi TD-𝘪 Advantage Campaign',
    disabled: false,
    value: 'tdi-advantage-campaign'
  },
  {
    text: 'Shop-Pay-Win with alrajhi bank Malaysia Campaign',
    disabled: false,
    value: 'shop-pay-win-campaign'
  },
  {
    text: '2026 Refer. Reward. Repeat. Campaign',
    disabled: false,
    value: 'refer-reward-repeat-2026'
  },
  {
    text: 'alrajhi bank Malaysia Hajj Campaign',
    disabled: false,
    value: 'hajj-campaign'
  },
  {
    text: 'alrajhi bank Malaysia x ZALORA Campaign 2026',
    disabled: false,
    value: 'zalora-campaign-2026'
  },
  {
    text: 'alrajhi bank Malaysia x CARS INTERNATIONAL Campaign 2026',
    disabled: false,
    value: 'cars-international-campaign-2026'
  },
  {
    text: 'alrajhi bank Malaysia x SITI KHADIJAH Campaign 2026',
    disabled: false,
    value: 'siti-khadijah-campaign-2026'
  },
  {
    text: 'alrajhi bank Malaysia Diamond & Affluent Perks Campaign',
    disabled: false,
    value: 'diamond-affluent-perks'
  },

  {
    text: 'Credit Cards',
    disabled: false,
    value: 'credit-cards'
  },
  {
    text: 'Debit Cards',
    disabled: false,
    value: 'debit-cards'
  },
  {
    text: 'Personal Financing-𝘪',
    disabled: false,
    value: 'personal-financing-i'
  },
  {
    text: 'Property Financing-𝘪',
    disabled: false,
    value: 'property-financing-i'
  },
  {
    text: 'GoldInvest-𝘪',
    disabled: false,
    value: 'goldinvest-i'
  },
  {
    text: 'Unit Trust funds',
    disabled: false,
    value: 'unit-trust-funds'
  },
  {
    text: 'Takaful products',
    disabled: false,
    value: 'takaful-products'
  },
  {
    text: 'Will writing services',
    disabled: false,
    value: 'will-writing-services'
  },
  {
    text: 'Affluent Banking/Diamond Affluent Banking',
    disabled: false,
    value: 'affluent-diamond-banking'
  },
  {
    text: 'Savings Accounts/Current Accounts',
    disabled: false,
    value: 'savings-current-accounts'
  },
  {
    text: 'MY alrajhi app',
    disabled: false,
    value: 'my-alrajhi-app'
  },
  {
    text: 'alrajhicashbiz@24seven',
    disabled: false,
    value: 'alrajhicashbiz-24seven'
  },
  {
    text: 'Others',
    disabled: false,
    value: 'others'
  }
]

export const sourceOfEnquiry = [
  {
    text: `-- Select --`,
    disabled: true,
    value: ``
  },
  {
    text: `Facebook`,
    disabled: false,
    value: `facebook`
  },

  {
    text: `Instagram`,
    disabled: false,
    value: `instagram`
  },
  {
    text: `TikTok`,
    disabled: false,
    value: `tiktok`
  },
  {
    text: `LinkedIn`,
    disabled: false,
    value: `linkedin`
  },
  {
    text: `YouTube`,
    disabled: false,
    value: `youtube`
  },
  {
    text: `Google search`,
    disabled: false,
    value: `google-search`
  },
  {
    text: `Online ads`,
    disabled: false,
    value: `online-ads`
  },
  {
    text: `Family and friends`,
    disabled: false,
    value: `family-and-friends`
  },
  {
    text: `Billboards`,
    disabled: false,
    value: `billboards`
  }
]

export const salutations = [
  { text: 'YAM - Yang Amat Mulia', disabled: false, value: 'yam' },
  { text: 'YM - Yang Mulia', disabled: false, value: 'ym' },
  { text: 'YAB - Yang Amat Berhormat', disabled: false, value: 'yab' },
  { text: 'YB - Yang Berhormat', disabled: false, value: 'yb' },
  { text: 'Tun', disabled: false, value: 'tun' },
  { text: 'Toh Puan', disabled: false, value: 'toh_puan' },
  { text: 'Tan Sri', disabled: false, value: 'tan_sri' },
  { text: 'Puan Sri', disabled: false, value: 'puan_sri' },
  { text: "Dato' Sri", disabled: false, value: 'dato_sri' },
  { text: 'Datin Sri', disabled: false, value: 'datin_sri' },
  { text: 'Datuk', disabled: false, value: 'datuk' },
  { text: "Dato'", disabled: false, value: 'dato' },
  { text: 'Datin', disabled: false, value: 'datin' },
  { text: 'Prof.', disabled: false, value: 'prof' },
  { text: 'Dr', disabled: false, value: 'dr' },
  { text: 'Haji', disabled: false, value: 'haji' },
  { text: 'Hajah', disabled: false, value: 'hajah' },
  { text: 'Mr/Encik', disabled: false, value: 'mr' },
  { text: 'Mrs/Puan', disabled: false, value: 'mrs' },
  { text: 'Ms/Cik', disabled: false, value: 'ms' }
]

export const preferredBranches = [
  'Bangsar Branch',
  'Kuching Branch',
  'Shah Alam Smart Financial Center',
  'Johor Bahru Smart Financial Center',
  'Kota Kinabalu Smart Financial Center',
  'Penang Smart Financial Center'
]

export const preferredContactTimes = [
  { text: 'In the morning', disabled: false, value: 'morning' },
  { text: 'In the afternoon', disabled: false, value: 'afternoon' }
]

export const preferredReachMethods = [
  { text: 'Email', disabled: false, value: 'email' },
  { text: 'Phone', disabled: false, value: 'phone' }
]

export const ProfitRates = [
  {
    text: '15.00% p.a.',
    disabled: false,
    value: 15
  },
  {
    text: '17.00% p.a.',
    disabled: false,
    value: 17
  },
  {
    text: '18.00% p.a.',
    disabled: false,
    value: 18
  }
]
